import React from "react";
import { container_classname } from "./constants";

interface StepByStepGuideProps {
    mainTitle?: string;
    description?: string;
    steps?: string[];
}

const defaultStepsData = [
    "Enter your WhatsApp number and website URL.",
    "Hit the 'Create AI Chatbot' button. Enjoy a cup of coffee.",
    "Before you're done, your virtual assistant is ready.",
];

const StepByStepGuide: React.FC<StepByStepGuideProps> = (props) => {
    const {
        mainTitle = "Gallabox's WhatsApp AI chatbot generator fixes just that.",
        description = "Here's all you need to do to generate your WhatsApp AI chatbot:",
        steps = defaultStepsData,
    } = props;
    return (
        <section className="lg:py-20 pt-16 pb-10" style={{ backgroundColor: "#EEF4FF" }}>
            <div className={`${container_classname}`}>
                <h2 className="md:text-6xl text-3xl font-semibold md:mb-12 mb-5" style={{ fontFamily: "Degular Display" }}>
                    {mainTitle}
                </h2>
                <p className="lg:text-xl text-base">{description}</p>
                <div className="mt-16 w-full flex lg:flex-row flex-col lg:gap-5 gap-14">
                    {steps.map((step, index) => {
                        return (
                            <div key={index} className="relative lg:w-1/3 w-full lg:mx-0 mx-auto bg-white border border-solid border-gray-200 rounded-lg px-8 pt-8 pb-5">
                                <div
                                    className="absolute text-white rounded-full flex items-center justify-center"
                                    style={{ width: "50px", height: "50px", backgroundColor: "#3364FA", top: "-26px", left: "43%" }}
                                >
                                    {index + 1}
                                </div>
                                <p className="lg:text-xl text-base lg:font-semibold font-medium text-center">{step}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default StepByStepGuide;
